export type ChatMessageAttributes = Record<string, string> | undefined;

export function getChatAttribute(attributes: ChatMessageAttributes, ...keys: string[]): string | undefined {
	if (!attributes) {
		return undefined;
	}

	for (const key of keys) {
		const directValue = attributes[key];
		if (directValue !== undefined) {
			return directValue;
		}

		const normalizedKey = key.toLowerCase();
		const matchedEntry = Object.entries(attributes).find(([attributeKey]) => attributeKey.toLowerCase() === normalizedKey);
		if (matchedEntry) {
			return matchedEntry[1];
		}
	}

	return undefined;
}

export function mergeChatAttributes(
	current: ChatMessageAttributes,
	next: ChatMessageAttributes,
): Record<string, string> | undefined {
	const merged: Record<string, string> = {};
	const keyByNormalizedName = new Map<string, string>();

	const append = (attributes: ChatMessageAttributes) => {
		for (const [key, value] of Object.entries(attributes ?? {})) {
			const normalizedKey = key.toLowerCase();
			const existingKey = keyByNormalizedName.get(normalizedKey);
			if (existingKey) {
				delete merged[existingKey];
			}

			keyByNormalizedName.set(normalizedKey, key);
			merged[key] = value;
		}
	};

	append(current);
	append(next);

	return Object.keys(merged).length > 0 ? merged : undefined;
}
